module.exports = __webpack_public_path__ + "img/fixed_menu_logo_ar.e9ad2aee.png";